import React, { useMemo, useState, useEffect, useCallback } from "react";
import MDSnackbar from "components/MDSnackbar";

export default function GlobalSnackbarHost() {
  const [open, setOpen] = useState(false);
  const [config, setConfig] = useState({
    color: "info",
    icon: "info",
    title: "Notis",
    content: "",
    dateTime: "",
    autoHideDuration: 10000,
  });

  const close = useCallback(() => setOpen(false), []);

  const show = useCallback((opts = {}) => {
    const now = new Date().toLocaleTimeString();
    setConfig((prev) => ({
      ...prev,
      color: opts.color || prev.color,
      icon: opts.icon || prev.icon,
      title: opts.title || prev.title,
      content: opts.content || prev.content,
      dateTime: now,
      autoHideDuration: typeof opts.autoHideDuration === "number" ? opts.autoHideDuration : 10000,
    }));
    setOpen(true);
  }, []);

  useEffect(() => {
    // Expose a global notify function and override window.alert to use snackbar
    window.appNotify = (opts) => show(opts);
    const originalAlert = window.alert;
    window.alert = (message) => {
      show({ color: "error", icon: "error", title: "Makluman", content: String(message), autoHideDuration: 10000 });
    };
    return () => {
      window.appNotify = undefined;
      window.alert = originalAlert;
    };
  }, [show]);

  return (
    <MDSnackbar
      open={open}
      color={config.color}
      icon={config.icon}
      title={config.title}
      dateTime={config.dateTime}
      content={config.content}
      close={close}
      bgWhite={false}
      autoHideDuration={config.autoHideDuration}
    />
  );
}
